var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rev-9",
    stroke: "none",
    strokeWidth: 1,
    fill: "white",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.200154,6.5998845 C17.6418968,6.26857744 17.6450267,5.73377001 17.200154,5.4001155 L14.799846,3.5998845 C14.3581032,3.26857744 14,3.44386482 14,4 L14,5 L1.00684547,5 C0.450780073,5 -5.68295411e-14,5.44386482 -5.68295411e-14,6 L-5.68295411e-14,6 C-5.68295411e-14,6.55228475 0.449948758,7 1.00684547,7 L14,7 L14,8 C14,8.55228475 14.3549733,8.73377001 14.799846,8.4001155 L17.200154,6.5998845 Z M2.27318164e-13,1 C2.27318164e-13,1.55228475 0.447489426,2 0.998502329,2 L12.0014977,2 C12.5529553,2 13,1.55613518 13,1 L13,1 C13,0.44771525 12.5525106,0 12.0014977,0 L0.998502329,0 C0.44704472,0 2.27318164e-13,0.443864822 2.27318164e-13,1 L2.27318164e-13,1 Z M2.27318164e-13,11 C2.27318164e-13,11.5522847 0.447489426,12 0.998502329,12 L12.0014977,12 C12.5529553,12 13,11.5561352 13,11 L13,11 C13,10.4477153 12.5525106,10 12.0014977,10 L0.998502329,10 C0.44704472,10 2.27318164e-13,10.4438648 2.27318164e-13,11 L2.27318164e-13,11 Z",
    id: "arrow"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.19e9a64c2699be7bbac2c6d1f1c64b93.svg";
export { ForwardRef as ReactComponent };